export const FILE_IP = "https://my-client.ch:8443/monitor/";
